import React from "react";

const teamMembers = [
  {
    id: 1,
    name: "priyank gupta",
    role: "Project Manager",
    image: "/assets/images/img.jpg",
  },
  {
    id: 2,
    name: "Dinesh verma",
    role: "CEO & Founder",
    image: "/assets/images/07.jpg",
  },
  {
    id: 3,
    name: "Nithin sharma",
    role: "Marketing Manager",
    image: "/assets/images/27.jpg",
  },
  {
    id: 4,
    name: "Anjali mehta",
    role: "System Engineer",
    image: "/assets/images/img.png",
  },
];

function TeamSection() {
  return (
    <section className="team-area py-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center mb-50">
            <span className="site-title-tagline">
              <i className="far fa-lightbulb-on"></i> Our Team
            </span>
            <h2 className="site-title">
              Meet With Our <span className="text-gradient">Experts</span>
            </h2>
          </div>
        </div>

        <div className="row g-4">
          {teamMembers.map((member) => (
            <div className="col-md-6 col-lg-3" key={member.id}>
              <div className="team-item">
                <div className="team-img">
                  <img src={member.image} alt={member.name} />
                </div>

                <div className="team-content">
                  <h4>{member.name}</h4>
                  <span>{member.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamSection;
